import { z } from 'zod';
import { UserSchema } from '../../entities/user/user.schema';
/**
 * Suspend Org Member Request Schema
 * POST /api/v2/org-members/:id/suspend
 *
 * No request body needed - user ID comes from URL params
 */ export const SuspendOrgMemberRequestSchema = z.object({});
/**
 * Suspend Org Member Response Schema
 * POST /api/v2/org-members/:id/suspend
 */ export const SuspendOrgMemberResponseSchema = z.object({
    data: UserSchema
});

//# sourceMappingURL=suspend-org-member.schema.js.map